import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortDown = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 12,
	viewBox: "0 0 14 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6667 9.33333H13.6667L11 12L8.33337 9.33333H10.3334V0H11.6667M0.333374 9.33333H7.00004V10.6667H0.333374M3.00004 1.33333V2.66667H0.333374V1.33333M0.333374 5.33333H5.00004V6.66667H0.333374V5.33333Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgSortDown);
export { ForwardRef as ReactComponent };
